import React from "react";
import classNames from "classnames";
import { ContextMenuTrigger } from "react-contextmenu";
import { useDrop } from "react-dnd";
import tinycolor from "tinycolor2";

import Event, { DraggableType } from "../shared/Event";

import styles from "./WeekView.less";
import { dispatch } from "rxjs/internal/observable/pairs";

const contextMenuCollect = (props) => ({
  eventId: props.eventId,
  jobId: props.jobId ? props.jobId : 0,
  date: props.date,
  evt: props.evt,
});

const getContextMenuIdForEvent = (e) => {
  if (e.bid) {
    return "BID_MENU";
  } else if (e.purchaseOrder) {
    return "DELIVERY_MENU";
  } else if (e.job) {
    return "JOB_MENU";
  } else if (
    e.datasheet ||
    e.customer ||
    e.description ||
    e.appttype ||
    e.evttype === "appointments"
  ) {
    return "APPOINTMENT_MENU";
  } else {
    return "NONE";
  }
};

const makeEventStyle = ({ color, datasheet, customer, crew }) => {
  var color = color;

  if (color == null) {
    if (
      datasheet &&
      datasheet !== null &&
      datasheet.salesperson !== null &&
      datasheet.salesperson.calendarColor != null
    ) {
      color = datasheet.salesperson.calendarColor;
    } else if (
      customer &&
      customer !== null &&
      customer.salesperson !== null &&
      customer.salesperson.calendarColor != null
    ) {
      color = customer.salesperson.calendarColor;
    } else if (
      crew &&
      crew !== null &&
      crew.resources !== null &&
      crew.resources.length > 0
    ) {
      color = crew.resources[0].calendarColor;
    }
  }

  return !color
    ? null
    : {
        backgroundColor: color,
        borderColor: tinycolor(color).darken(40),
        color: tinycolor(color).getBrightness() < 150 ? "#fff" : "#000",
      };
};

const Day = ({
  active,
  crew,
  date,
  settings,
  events,
  mode,
  onReschedule,
  onScheduleBid,
  onScheduleDelivery,
  onScheduleJob,
  onSheeduleAppointment,
  updateSettings,
}) => {
  const [{ canDrop, isDragging, isOver }, drop] = useDrop({
    accept: [DraggableType, "bid", "job", "purchaseOrder", "appointment"],
    canDrop: (item) => {
      switch (item.type) {
        case "bid":
          // Bids cannot be scheduled to a crew
          return !crew;
        case "event":
          const { event } = item;
          if (event.bid) {
            // Bids cannot be scheduled to a crew
            return !crew;
          } else {
            return !!crew; //!crew || !event.office || crew.offices.some(o => o.id === event.office.id);
          }
        case "job":
          // Job office must match crew's office
          const { job } = item;
          //console.log(crew);
          return true; // || !job.office || crew.offices.some(o => o.id === job.office.id);
        case "purchaseOrder":
          // Purchase order office must match crew's office
          const { purchaseOrder } = item;
          return (
            !crew ||
            !purchaseOrder.office ||
            (crew.offices &&
              crew.offices.some((o) => o.id === purchaseOrder.office.id))
          );

        case "appointment":
          //console.log(item);
          return true;

        default:
          break;
      }
      return true;
    },
    collect: (monitor) => ({
      canDrop: !!monitor.canDrop(),
      isDragging: !!monitor.getItem(),
      isOver: !!monitor.isOver(),
    }),
    drop: (item) => {
      switch (item.type) {
        case "bid":
          const { bidId } = item;
          onScheduleBid && onScheduleBid(bidId, date.format("YYYY-MM-DD"));
          break;
        case "event":
          const { eventId } = item;
          let evtcrew = item.event.crew;
          if (item.event.crew && crew.equipment) {
            if (item.event.crew.equipment) {
              //evtcrew.crew = {...crew.equipment,  "resrouces":item.event.crew.resources};
              evtcrew.equipment = crew.equipment;
            } else {
              evtcrew = {
                resources: item.event.crew.resources,
                equipment: crew.equipment,
              };
            }
          } else if (item.event.crew) {
            // crew but no equipment
            evtcrew = {
              resources: item.event.crew.resources,
              equipment: crew.equipment,
            };
          } else if (crew) {
            evtcrew = crew;
          }

          onReschedule &&
            onReschedule(eventId, date.format("YYYY-MM-DD"), evtcrew, mode);
          break;
        case "job":
          const { jobId } = item;
          onScheduleJob &&
            onScheduleJob(jobId, crew, date.format("YYYY-MM-DD"));

          break;
        case "purchaseOrder":
          const { purchaseOrderId } = item;
          onScheduleDelivery &&
            onScheduleDelivery(
              purchaseOrderId,
              date.format("YYYY-MM-DD"),
              crew
            );
          break;
        case "appointment":
          var datasheetid = null;
          var customerid = null;
          var appointmenttype = null;
          if (item.appointment.eventtype === "datasheet")
            datasheetid = item.appointment.id;
          if (item.appointment.eventtype === "customer")
            customerid = item.appointment.id;
          onSheeduleAppointment(
            datasheetid,
            customerid,
            appointmenttype,
            crew,
            date.format("YYYY-MM-DD"),
            null,
            date.format("YYYY-MM-DD"),
            null,
            ""
          );
          updateSettings({
            entity: "appointments",
            schedulerView: "equipment",
          });
          break;
        default:
          break;
      }
    },
  });

  events = events.filter(function (e) {
    return e.evttype === settings.entity;
  });

  switch (settings.sortoption) {
    case "Date":
      events.sort(function (a, b) {
        // nulls sort after anything else
        if (a.startTime === null) {
          return 1;
        }
        if (b.startTime === null) {
          return -1;
        }

        if (a.startTime < b.startTime) return -1;
        if (a.startTime > b.startTime) return 1;
        else return 0;
      });
      break;
    case "Customer":
      events.sort(function (a, b) {
        if (a.customer && b.customer) {
          return a.customer.name.localeCompare(b.customer.name);
        } else if (a.datasheet && b.datasheet) {
          if (a.datasheet.customer && b.datasheet.customer) {
            return a.datasheet.customer.name.localeCompare(
              b.datasheet.customer.name
            );
          } else {
            return b.id - a.id;
          }
        } else if (a.job && b.job) {
          if (a.job.customer && b.job.customer) {
            return a.job.customer.name.localeCompare(b.job.customer.name);
          } else {
            return b.id - a.id;
          }
        } else if (a.bid && b.bid) {
          if (a.bid.customer && b.bid.customer) {
            return a.bid.customer.name.localeCompare(b.bid.customer.name);
          } else {
            return b.id - a.id;
          }
        } else {
          return b.id - a.id;
        }
      });

      break;
    case "Address":
      events.sort(function (a, b) {
        if (a.datasheet && b.datasheet) {
          if (
            a.datasheet.customer &&
            b.datasheet.customer &&
            a.datasheet.customer.address &&
            b.datasheet.customer.address
          ) {
            const compareState =
              a.datasheet.customer.address.state.localeCompare(
                b.datasheet.customer.address.state
              );
            const compareCity = a.datasheet.customer.address.city.localeCompare(
              b.datasheet.customer.address.city
            );
            const compareLine1 =
              a.datasheet.customer.address.line1.localeCompare(
                b.datasheet.customer.address.line1
              );
            const compareLine2 =
              a.datasheet.customer.address.line2.localeCompare(
                b.datasheet.customer.address.line2
              );
            return compareState || compareCity || compareLine1 || compareLine2;
          }
        } else if (a.customer && b.customer) {
          if (
            a.customer &&
            b.customer &&
            a.customer.address &&
            b.customer.address
          ) {
            const compareState = a.customer.address.state.localeCompare(
              b.customer.address.state
            );
            const compareCity = a.customer.address.city.localeCompare(
              b.customer.address.city
            );
            const compareLine1 = a.customer.address.line1.localeCompare(
              b.customer.address.line1
            );
            const compareLine2 = a.customer.address.line2.localeCompare(
              b.customer.address.line2
            );
            return compareState || compareCity || compareLine1 || compareLine2;
          }
        } else if (a.job && b.job) {
          const compareState = a.job.address.state.localeCompare(
            b.job.address.state
          );
          const compareCity = a.job.address.city.localeCompare(
            b.job.address.city
          );
          const compareLine1 = a.job.address.line1.localeCompare(
            b.job.address.line1
          );
          const compareLine2 = a.job.address.line2.localeCompare(
            b.job.address.line2
          );
          return compareState || compareCity || compareLine1 || compareLine2;
        } else if (a.bid && b.bid) {
          const compareState = a.bid.address.state.localeCompare(
            b.bid.address.state
          );
          const compareCity = a.bid.address.city.localeCompare(
            b.bid.address.city
          );
          const compareLine1 = a.bid.address.line1.localeCompare(
            b.bid.address.line1
          );
          const compareLine2 = a.bid.address.line2.localeCompare(
            b.bid.address.line2
          );
          return compareState || compareCity || compareLine1 || compareLine2;
        } else {
          return b.id - a.id;
        }
      });
      break;
  }

  return (
    <div
      className={classNames({
        [styles.column]: true,
        [styles.day]: true,
        [styles.active]: active || (canDrop && isOver),
        [styles.disabled]: isDragging && !canDrop,
      })}
      ref={drop}
    >
      {events.map((e) => (
        <ContextMenuTrigger
          collect={contextMenuCollect}
          eventId={e.id}
          jobId={e.job && e.job.id}
          date={date}
          evt={e}
          holdToDisplay={1000}
          id={getContextMenuIdForEvent(e)}
          key={e.id}
        >
          <Event
            className={styles.event}
            eventId={e.id}
            event={e}
            jobId={e.job && e.job.id}
            showActions={false}
            styleSelector={makeEventStyle}
          />
        </ContextMenuTrigger>
      ))}
    </div>
  );
};

export default Day;
